export default "__VITE_ASSET__BVA395lN__"